import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { color, motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import DesignCrmCarousel from "../../components/v4/designCarousel/DesignCarousel";
import industryIntegration from "../../images/v4/TgPages/salesDevReps/integrateRight.png";

import salesReppageHerobg from "../../images/v4/TgPages/salesDevReps/heroBanner.png";
import salesCrmCarouselbg from "../../images/v4/salesManagers/salesCrmbg.png";
import realWorldbg from "../../images/v4/TgPages/salesDevReps/realworld.png";

import salesImg1 from "../../images/v4/TgPages/salesDevReps/salesImg/img1.svg";
import salesImg2 from "../../images/v4/TgPages/salesDevReps/salesImg/img2.svg";
import salesImg3 from "../../images/v4/TgPages/salesDevReps/salesImg/img3.svg";
import salesImg4 from "../../images/v4/TgPages/salesDevReps/salesImg/img4.svg";
import salesImg5 from "../../images/v4/TgPages/salesDevReps/salesImg/img5.svg";
import salesImg6 from "../../images/v4/TgPages/salesDevReps/salesImg/img6.svg";

import adaptImg1 from "../../images/v4/salesManagers/clientSlider/img1.png";
import adaptImg2 from "../../images/v4/salesManagers/clientSlider/img2.png";
import adaptImg3 from "../../images/v4/salesManagers/clientSlider/img3.png";
import adaptImg4 from "../../images/v4/salesManagers/clientSlider/img4.png";
import adaptImg5 from "../../images/v4/salesManagers/clientSlider/img5.png";
import adaptImg6 from "../../images/v4/salesManagers/clientSlider/img6.png";
import adaptImg7 from "../../images/v4/salesManagers/clientSlider/img7.png";

import bussinessSuccessbg from "../../images/v4/salesManagers/bussinessSuccess.png";
import salesRepHeroImg from "../../images/v4/TgPages/salesDevReps/heroBg.png";
import clientbg from "../../images/v4/TgPages/salesDevReps/clientBg.png";

import leadCaptureIcon from "../../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../../images/v4/industryPage/videoConference.png";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import bannerTick from "../../images/v4/salesReps/heroTick.svg";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/salesReps/topcrm/hubspot.png";
import compareItemImg3 from "../../images/v4/salesManagers/topcrm/zoho.png";
import compareItemImg4 from "../../images/v4/salesManagers/topcrm/pipedrive.png";
import compareItemImg5 from "../../images/v4/salesManagers/topcrm/freshsale.png";

import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";

import realWorldImage2 from "../../images/v4/TgPages/salesDevReps/realWorld/img1.png";
import realWorldImage3 from "../../images/v4/TgPages/salesDevReps/realWorld/img2.png";
import realWorldImage4 from "../../images/v4/TgPages/salesDevReps/realWorld/img3.png";
import realWorldImage5 from "../../images/v4/TgPages/salesDevReps/realWorld/img4.png";
import realWorldImage6 from "../../images/v4/TgPages/salesDevReps/realWorld/img5.png";

import broadcastImg1 from "../../images/v4/salesReps/Designfor/broadcast1.png";
import broadcastImg2 from "../../images/v4/salesReps/Designfor/broadcast2.png";
import broadcastImg3 from "../../images/v4/salesReps/Designfor/broadcast3.png";
import broadcastImg4 from "../../images/v4/salesReps/Designfor/broadcast4.png";
import broadcastImg5 from "../../images/v4/salesReps/Designfor/broadcast5.png";

import experienceImg2 from "../../images/v4/TgPages/salesDevReps/expericence/img1.png";
import experienceImg3 from "../../images/v4/TgPages/salesDevReps/expericence/img2.png";
import experienceImg4 from "../../images/v4/TgPages/salesDevReps/expericence/img3.png";
import experienceImg5 from "../../images/v4/TgPages/salesDevReps/expericence/img4.png";
import experienceImg6 from "../../images/v4/TgPages/salesDevReps/expericence/img5.png";
import designGradeBg from "../../images/v4/TgPages/salesDevReps/designBg.png";
import salesdevpageHerobg from "../../images/v4/TgPages/salesDevReps/saleslogobg.png";

import gradebg1 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg1.png";
import gradebg2 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg2.png";
import gradebg3 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg3.png";
import gradebg4 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg4.png";
import gradebg5 from "../../images/v4/TgPages/salesDevReps/gradientBg/bg5.png";
import designbg from "../../images/v4/TgPages/designCrm.png";
const useStyles = makeStyles((theme) => ({
  SalesRepSection: {
    backgroundSize: "cover",
    backgroundImage: `url(${salesReppageHerobg})`,
    padding: "100px 0 0",
    backgroundPosition: "center",
    minHeight: "100vh",
    "@media only screen and (max-width: 1440px)": {
      backgroundPosition: "top",
      padding: "60px 0 0 ",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "120px 0 0",
      "& .centerContainer": {
        width: "90%",
        marginTop: "50px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      padding: "0",
      "& .centerContainer": {
        width: "95%",
        marginTop: "40px",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "20px 0 0",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
        gap: "20px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      padding: "0",
      "& .centerContainer": {
        marginTop: "20px",
        gap: "16px",
      },
    },
  },
  salesRepContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "20px",
    },
  },
  salesSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "32px",
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      alignItems: "flex-start",
      textAlign: "left",
    },
  },
  aiSectionRight: {
    width: "50%",
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      paddingTop: "20%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      paddingTop: "0",
      maxWidth: "500px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    color: "#fff",
    maxWidth: "1200px",
    margin: "0 auto 32px",

    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "& p": {
      marginBottom: "16px",
      textAlign: "left",
      paddingRight: "80px",
    },
    "@media only screen and (max-width: 1024px)": {
      "& p": {
        paddingRight: "40px",
        fontSize: "18px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& p": {
        paddingRight: "0",
        textAlign: "center",
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& p": {
        fontSize: "13px",
      },
    },
  },

  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingTop: "100px",
    position: "relative",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
      "@media only screen and (max-width: 768px)": {
        paddingBottom: "20px!important",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "80px",
      backgroundPositionX: "center",
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "60px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "60px 0",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "40px 0",
    },
  },
  bussinessSuccessContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "0 auto",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  },
  integrationHeaderItem: {
    width: "100%",
    maxWidth: "1200px",
    textAlign: "center",
    marginBottom: "90px",
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "18px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
      marginTop: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      marginTop: "25px",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "12px",
      marginTop: "15px",
    },
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    overflow: "auto",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "5px",
    },
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px",
    },
  },
  tabCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "32px",
    gap: "40px",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
    },
  },
  tabCardLeftContainer: {
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    alignItems: "flex-start",
    "@media only screen and (max-width: 768px)": {
      alignItems: "center",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    width: "24px!important",
    "& img": {
      width: "100%",
      marginTop: "6px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "24px!important",
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 1024px)": {
      "& .centerContainer": {
        width: "90%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .centerContainer": {
        width: "95%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& .centerContainer": {
        gap: "16px",
      },
    },
  },
  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },

    "@media only screen and (max-width: 1024px)": {
      "& section": {
        padding: "0px 0 35px !important",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& section": {
        padding: "0px 0 30px !important",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
    "@media only screen and (max-width: 480px)": {
      "& section": {
        padding: "0px 0 25px !important",
      },
    },
  },
  integrationSection: {
    background: " #fff",
    backgroundSize: "cover",
  },
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: "70px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 768px)": {
        width: "100%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "@media only screen and (max-width: 1024px)": {
        marginTop: "35px",
      },
      "@media only screen and (max-width: 768px)": {
        marginTop: "30px",
      },
      "@media only screen and (max-width: 600px)": {
        marginTop: "20px",
      },
      "@media only screen and (max-width: 480px)": {
        marginTop: "15px",
      },
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },
  integrationRightImage: {
    width: "100%",
  },
  combineSection: {
    position: "relative",
    paddingTop: "64px",
    backgroundImage: `url(${salesdevpageHerobg})`,
    backgroundSize: "cover",
    paddingBottom: "220px",
    "@media(max-width:600px)": {
      paddingBottom: "90px",
    },
  },
  adaptSlider: {
    padding: "15px 0!important",
    "@media only screen and (max-width: 1024px)": {
      padding: "15px 4rem 50px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "15px 2rem 40px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "15px 10px 30px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px",
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "100%",
    transform: "translate(-50% ,-50%)",
    left: "50%",
    right: "0",
  },
  bannerPoint: {
    display: "flex",
    flexDirection: "column",
    gap: "22px",
    marginBottom: "20px",
    "@media only screen and (max-width: 1024px)": {
      gap: "20px",
      marginBottom: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "18px",
      marginBottom: "16px",
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      gap: "16px",
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "14px",
      marginBottom: "12px",
    },
  },
  banerPointItem: {
    display: "flex",
    alignItems: "center",
    gap: "16px",

    "& img": {
      width: "24px",
      height: "24px",
    },
    "& p": {
      fontSize: "18px",
    },
    "@media only screen and (max-width: 1024px)": {
      gap: "14px",
      "& img": {
        width: "30px",
        height: "30px",
      },
      "& p": {
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
      "& img": {
        width: "28px",
        height: "28px",
      },
      "& p": {
        fontSize: "16px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      gap: "10px",
      "& img": {
        width: "26px",
        height: "26px",
      },
      "& p": {
        fontSize: "14px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
      "& img": {
        width: "24px",
        height: "24px",
      },
    },
  },
  salesCrmCarousel: {
    background: " #F7F1FB",
    "& .header-section": {
      width: "50%",
      "& h2": {
        marginBottom: "32px",
      },
      "& p": {
        marginBottom: "0",
      },
      "@media(max-width:768px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 1024px)": {
      "& .header": {
        width: "60%",
      },
    },
    "@media only screen and (max-width: 768px)": {
      "& .header": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
    },

    "& .crmDevReps": {
      display: "flex",
      alignItems: "center",
      gap: "24px",
      padding: "40px 0",
      "& .cardBlocksSales": {
        width: "50%",
        display: "flex",
        alignItems: "stretch",
        gap: "24px",
        flexWrap: "wrap",
        "@media(max-width:1024px)": {
          width: "100%",
        },
      },
      "@media(max-width:1024px)": {
        flexDirection: "column",
        padding: "0",
        "& .header-section": {
          width: "100%",
          "& h2": {
            marginBottom: "16px",
          },
          "& p": {
            marginBottom: "24px",
          },
        },
        "& .cardBlocksSales": {
          width: "100%",
        },
      },
    },
  },
  adaptsBox: {
    width: "30%",
    gap: "16px",
    display: "flex",
    flexDirection: "column",
    padding: "16px",
    borderRadius: "16px",
    color: "#fff",
    position: "relative",
    backdropFilter: "blur(20px)",
    overflow: "hidden",
    "&.sblueCard": {
      background: "linear-gradient(180deg, #09939A 0%, #783CA8 100%)",
    },
    "&.greenCard": {
      background: "linear-gradient(180deg, #009A99 0%, #053333 100%)",
    },
    "&.purpleCard": {
      background: "linear-gradient(180deg, #783CA8 0%, #431B63 100%)",
    },
    "&.blueCard": {
      background: "linear-gradient(180deg, #028BA6 0%, #014957 100%)",
    },
    "&.regularCard": {
      background: "linear-gradient(180deg, #2575BA 0%, #092E4E 100%)",
    },
    "&.purpledark": {
      background: "linear-gradient(180deg, #31114B 0%, #783CA8 100%)",
    },
    "@media(max-width:520px)": {
      width: "45%",
    },
    "@media(max-width:350px)": {
      width: "100%",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    "& img": {
      width: "40px",
      height: "40px",
    },
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "180px",
      paddingBottom: "70px",
      "& .header": {
        width: "80%",
        gap: "28px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "150px",
      paddingBottom: "60px",
      "& .header": {
        width: "90%",
        gap: "24px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "600px",
      paddingBottom: "40px",
      "& .container:first-child": {
        padding: "0px 15px",
      },
      "& .header": {
        width: "100%",
        gap: "20px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      paddingTop: "500px",
      paddingBottom: "30px",
      "& .header": {
        gap: "16px",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
    "@media only screen and (max-width: 1024px)": {
      padding: "12px 16px",
    },
    "@media only screen and (max-width: 768px)": {
      padding: "10px 14px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "8px 12px",
    },
    "@media only screen and (max-width: 480px)": {
      padding: "6px 10px",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 1024px)": {
      width: "35%",
      top: "80px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 1024px)": {
      width: "65%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
    "@media only screen and (max-width: 1024px)": {
      marginBottom: "50px",
      gap: "18px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "40px",
      gap: "16px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "30px",
      gap: "15px",
    },
    "@media only screen and (max-width: 480px)": {
      marginBottom: "25px",
      gap: "12px",
    },
  },
  experienceContainer: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "& .centerContainer": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      "@media only screen and (max-width: 1024px)": {
        width: "80%",
      },
      "@media only screen and (max-width: 768px)": {
        width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
  },
  experienceInnerContainer: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    gap: "40px",
    "@media only screen and (max-width: 1024px)": {
      gap: "30px",
    },
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "20px",
      alignItems: "flex-start",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "15px",
    },
  },
  experienceContainerLeft: {
    width: "40%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
    "& .exp-desc": {
      marginBottom: "24px",
    },
    "& .view-more-link": {
      textDecoration: "underline",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "& img": {
        display: "inline-block!important",
        width: "16px!important",
        height: "16px",
        marginTop: "3px!important",
        transition: "transform 0.5s ease",
      },
      "&:hover": {
        color: "#010F1D",
        "& img": {
          transform: "translateX(5px)",
        },
      },
    },
    "@media only screen and (max-width: 1024px)": {
      width: "50%",
      gap: "20px",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      gap: "24px",
      alignItems: "center",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginTop: "30px",
      alignItems: "flex-start",
      textAlign: "left",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "18px",
    },
  },
  experienceContainerRight: {
    width: "60%",
    minHeight: "450px",

    "@media only screen and (max-width: 768px)": {
      display: "none",
    },
    "& .rightContent": {
      padding: "32px",
      gap: "46px",
      borderRadius: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      height: "100%",
      "& p": {
        color: "#fff",
      },
      "& img": {
        width: "100%",
      },
    },
  },
  faqHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 1024px)": {
      gap: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      gap: "12px",
    },
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
      gap: "10px",
    },
    "@media only screen and (max-width: 480px)": {
      gap: "8px",
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  collapseBody: {
    display: "none",
    margin: "0",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      display: "block",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
        padding: "16px",
        borderRadius: "16px",
        overflow: "hidden",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0  ",
    "& img": {
      display: "none",
    },
    "@media only screen and (max-width: 1024px)": {
      margin: "8px 0 0",
    },
    "@media only screen and (max-width: 768px)": {
      margin: "6px 0 0",
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "12px",
      },
    },
    "@media only screen and (max-width: 600px)": {
      "& img": {
        display: "block",
        width: "100%",
        marginTop: "15px",
      },
    },
    "@media only screen and (max-width: 480px)": {
      margin: "5px 0 0",
      "& img": {
        marginTop: "10px",
      },
    },
  },

  accordianTabs: {
    position: "relative",
    "& .headercenterContainer": {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "64px",
      gap: "100px",
      width: "100%",
      flexDirection: "row",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "50%",
      },
      "@media only screen and (max-width: 768px)": {
        flexDirection: "column",
        gap: "24px",
        "& h2": {
          width: "100%",
          textAlign: "center",
        },
        "& p": {
          width: "100%",
          textAlign: "center",
        },
      },
    },
  },
  realWorldTabs: {
    backgroundImage: `url(${realWorldbg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "300px",
    "& h2": {
      textAlign: "center",
    },
    "& .container": {
      padding: "0 0 120px",
    },
    "@media only screen and (max-width: 1024px)": {
      paddingTop: "250px",
      "& .container": {
        padding: "0 24px 65px",
      },
    },
    "@media only screen and (max-width: 768px)": {
      paddingTop: "280px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "170px",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "100%",
      margin: "0 auto",
      textAlign: "center",
      "& h2": {
        width: "80%",
      },
    },
    "@media only screen and (max-width: 1200px)": {
      "& .centerContainer": {
        "& h2": {
          width: "100%",
        },
      },
    },
  },

  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      marginTop: "15px",
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
    "@media only screen and (max-width: 768px)": {
      marginBottom: "15px",
    },
    "@media only screen and (max-width: 600px)": {
      marginBottom: "12px",
    },
  },
  integrationLeft: {
    "@media only screen and (max-width: 768px)": {
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      textAlign: "left",
    },
    "& p": {
      marginTop: "16px",
    },
  },
  integrationRight: {
    "@media only screen and (max-width: 768px)": {
      maxWidth: "500px",
      margin: "0 auto",
    },
    "@media only screen and (max-width: 600px)": {
      maxWidth: "400px",
    },
    "@media only screen and (max-width: 480px)": {
      maxWidth: "350px",
    },
  },

  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  broadcastBox: {
    padding: "32px 32px 0",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "0 auto",

    "& img": {
      maxWidth: "80%",
      width: "auto",
      height: "auto",
      margin: "24px auto 0",
      display: "table",
      "@media(max-width: 768px)": {
        width: "auto",
        maxWidth: "90%",
        height: "auto",
      },
    },
  },
  designCrmCarousel: {
    backgroundImage: `url(${designGradeBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .designHeader": {
      maxWidth: "55%",
      "& h2": {
        marginBottom: "24px",
      },
      "& p": {
        marginBottom: "16px",
        fontSize: "20px",
      },
      "@media(max-width:768px)": {
        maxWidth: "100%",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "stretch",
      "& .swiper-slide": {
        height: "auto!important",
      },
    },
    "@media(max-width:768px)": {
      "& .swiper-wrapper": {
        padding: "0 24px ",
      },
    },
    ".swiper-slide": {
      width: "100%!important",
    },
  },
  broadcastContainerInner: {
    display: "flex",
    flexDirection: "column-reverse",
    paddingBottom: "86px",
    "@media(max-width:1024px)": {
      padding: "0 50px 32px!important",
    },
    "@media(max-width:600px)": {
      padding: "0 0 32px!important",
    },
    "& .swiper-button-prev": {
      top: "100px !important",
      left: "auto",
      right: "200px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
    "& .swiper-button-next": {
      top: "100px !important",
      right: "100px",
      color: "#010f1d",
      width: "78px",
      height: "78px",
      borderRadius: "50%",
      border: "2px solid #53677c",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:after": {
        fontSize: "24px",
      },
    },
  },
  faqBoxAccordian: {
    padding: "16px 24px",
    background: "#fff",
    borderRadius: "16px",
    position: "relative",
    transition: "all 0.3s ease",
    overflow: "hidden",
    width: "100%",
    "&:after": {
      content: '""',
      position: "absolute",
      left: "0",
      top: "0",
      width: "100%",
      height: "1px",
      background: "rgb(255, 255, 255)",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      background: "#B1DBFF",
      background:
        "linear-gradient(90deg,rgba(32, 142, 236, 1) 25%, rgba(158, 90, 213, 1) 54%, rgba(255, 255, 255, 1) 80%)",
      left: "-16px",
      borderRadius: "16px",
      top: "0",
      width: "100%",
      height: "2px",
      transform: "scaleX(0) scaleY(1)",
      transformOrigin: "left",
      zIndex: 1,
    },
    "&.active": {
      background: "linear-gradient(270deg, #F8FCFF 0%, #E0EFFD 100%)",
      "&:before": {
        animation: "growTimerY 10s linear forwards", // Same as JS interval
      },
    },
    "& .body": {
      margin: "0",
    },
    "& .exp-desc": {
      margin: "10px 0 16px",
      whiteSpace: "nowrap",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      "@media(max-width:768px)": {
        whiteSpace: "normal",
        overflow: "visible",
        textAlign: "left",
        textOverflow: "unset",
      },
    },
  },
  experienceHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "column",
    "@media(max-width:768px)": {
      "& p": {
        display: "none",
      },
    },
  },
  topFiveHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  testimonials: {
    background: "#e9f4fe",
    paddingBottom: "50px",
    "@media(max-width:1025px)": {
      paddingBottom: "24px",
    },
  },
  smallCardContainer: {
    marginTop: "30px",
    width: "100%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    "& $cardContainer": {
      width: "32%",
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      marginTop: "16px",
      gap: "15px",
      "& $cardContainer": {
        height: "400px",
        width: "100%",
        padding: "16px",
      },
    },
  },
  cardContainer: {
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "18px",
    padding: "25px",
    background: "rgba(0, 44, 81, 0.4)",
    backdropFilter: "blur(20px)",
    height: "320px",
    position: "relative",
    overflow: "hidden",

    "@media(max-width:1024px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
      },
    },
    "@media(max-width:992px)": {
      "&.bannerCard": {
        width: "48%",
        minWidth: "48%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
    "@media(max-width:600px)": {
      "&.bannerCard": {
        width: "46%",
        minWidth: "46%",
        height: "auto",
        "& h3": {
          margin: "0",
        },
      },
    },
  },
  Client: {
    position: "relative",
    zIndex: "10",
    backgroundImage: `url(${clientbg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    "@media(max-width:1024px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "25px!important",
        },
      },
    },

    "@media(max-width:600px)": {
      "& .client-logo": {
        "& img": {
          width: "auto",
          height: "20px!important",
        },
      },
    },

    "& p": {
      textAlign: "center",
      marginBottom: "64px",
      "@media(max-width:1024px)": {
        marginBottom: "32px",
      },

      "@media(max-width: 600px)": {
        marginBottom: "18px",
      },
    },
    "& .client-logo": {
      width: "auto!important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        width: "auto",
        height: "35px",
      },
    },
  },
}));

const AUTO_PLAY_INTERVAL = 10000;

const experienceList = [
  {
    title: "Respond instantly with AI-powered AssistAI",
    alt: "Try AssistAI",
    lintText: "Try AssistAI",
    linkUrl: "https://peppercloud.com/ai-crm-assistant", // placeholder link (update if you have the exact URL)
    img: experienceImg2,
    bgImg: gradebg1,
    desc: "Handle dozens of conversations with professional, context-aware replies instantly. AssistAI suggests smart responses, enables you to modify the replies, change tone and do more. AssistAI also empowers the team to access the necessary information instantly using preloaded knowledge base.",
  },
  {
    title: "Seamless WhatsApp communication",
    alt: "More about WhatsApp CRM",
    lintText: "More about WhatsApp CRM",
    linkUrl: "https://peppercloud.com/whatsapp-crm-integration", // placeholder link
    img: experienceImg3,
    bgImg: gradebg2,
    desc: "Send broadcasts, 1:1 messages, and automated flows without leaving your CRM using WhatsApp integration. Use templates, share product catalogs, trigger interactive messages for higher conversions, auto-capture leads, enable easy appointment booking, and more with WhatsApp CRM.",
  },
  {
    title: "Automate follow-ups and workflows",
    alt: "Try workflow automation",
    lintText: "Try workflow automation",
    linkUrl: "https://peppercloud.com/sales-crm-features/workflow-automation/",
    img: experienceImg4,
    bgImg: gradebg3,
    desc: "From drip campaigns to next-step triggers, Pepper Cloud smart workflows handle repetitive tasks so you can focus on booking meetings. Broadcast messages, schedule outreach tasks, and trigger next steps based on lead actions. Enable SDRs to spend more time engaging and less time updating records.",
  },
  {
    title: "Complete prospect view and activity history",
    alt: "Know your prospects",
    lintText: "Know your prospects",
    linkUrl: "https://peppercloud.com/360-customer-view", // placeholder link
    img: experienceImg5,
    bgImg: gradebg4,
    desc: "Get the complete context and lead details before meetings. Every conversation, task, and interaction is logged automatically, giving you a 360° view of each prospect so you always know exactly where to pick up. No guesswork for SDRs, just clarity and confidence.",
  },
  {
    title: "Work from anywhere with mobile CRM",
    alt: "Try mobile CRM",
    lintText: "Try mobile CRM",
    linkUrl: "https://peppercloud.com/best-mobile-crm-system-app-ios-android/",
    img: experienceImg6,
    bgImg: gradebg5,
    desc: "Whether working from home or in the field, SDRs can fully operate through Pepper Cloud’s mobile app. Pepper Cloud stands out with AI-driven automation, multichannel communication, and real-time reporting — all designed to help SDRs qualify faster and close more meetings.",
  },
];

const tabContentData = [
  {
    tabContent: [
      {
        heading: "AssistAI replies",
        content:
          "Respond to technical queries instantly with context-aware suggestions for faster qualification.",
        alt: "AssistAI replies",
      },
      {
        heading: "WhatsApp flows",
        content:
          "Guide free trial users through onboarding using automated step-by-step messaging.",
        alt: "WhatsApp flows",
      },
      {
        heading: "Sales pipelines",
        content:
          "Manage lead stages like demo scheduled or trial active with full visibility.",
        alt: "Sales pipelines",
      },
      {
        heading: "Sales activity reports",
        content:
          "Track demo completions, trial conversions, and SDR performance weekly.",
        alt: "Sales activity reports",
      },
    ],
    image: realWorldImage2,
    alt: "IT services",
    subtitle:
      "SDRs from IT businesses engage with trial users, demo requests, and technical leads, needing fast, consistent communication to push leads down the funnel.",
  },
  {
    tabContent: [
      {
        heading: "Lead tracking",
        content:
          "Prioritise outreach to students who showed interest in specific courses or opened emails.",
        alt: "Lead tracking",
      },
      {
        heading: "Message templates",
        content:
          "Send course info, pricing, and batch schedules instantly with pre-approved content.",
        alt: "Message templates",
      },
      {
        heading: "WhatsApp broadcasts",
        content:
          "Share webinar invites or new course alerts with multiple learners in one go.",
        alt: "WhatsApp broadcasts",
      },
      {
        heading: "Mobile CRM",
        content:
          "Manage enrolment follow-ups and demo calls remotely from events or campuses.",
        alt: "Mobile CRM",
      },
    ],
    image: realWorldImage3,
    alt: "EdTech and online training",
    subtitle:
      "SDRs in EdTech need to engage learners, share course info, and schedule demos or counselling calls efficiently.",
  },
  {
    tabContent: [
      {
        heading: "AI Assist responses",
        content:
          "Deliver accurate, compliant replies on policies, loans, or investment options instantly.",
        alt: "AI Assist responses",
      },
      {
        heading: "WhatsApp templates",
        content:
          "Share product brochures, eligibility criteria, and plan comparisons securely.",
        alt: "WhatsApp templates",
      },
      {
        heading: "Timeline activity log",
        content:
          "View all past conversations, documents sent, and scheduled appointments.",
        alt: "Timeline activity log",
      },
      {
        heading: "Engagement alerts",
        content:
          "Get real-time notifications when a lead opens pricing documents or clicks a quote link.",
        alt: "Engagement alerts",
      },
    ],
    image: realWorldImage4,
    alt: "Financial services and insurance",
    subtitle:
      "SDRs in finance need to simplify complex offerings while ensuring compliance and timely touchpoints.",
  },
  {
    tabContent: [
      {
        heading: "Prebuilt quick replies",
        content:
          "Send service overviews, pricing, or portfolio links in seconds.",
        alt: "Prebuilt quick replies",
      },
      {
        heading: "Activity planner",
        content:
          "Schedule discovery calls, proposal follow-ups, and content reviews with automated tasks.",
        alt: "Activity planner",
      },
      {
        heading: "CRM on mobile",
        content:
          "Stay connected to leads and update interactions from client meetings or shoots.",
        alt: "CRM on mobile",
      },
      {
        heading: "Automated WhatsApp flows",
        content:
          "Qualify new leads through predefined questions before assigning to sales.",
        alt: "Automated WhatsApp flows",
      },
    ],
    image: realWorldImage5,
    alt: "Digital marketing and advertising agencies",
    subtitle:
      "SDRs in agencies qualify inbound leads, pitch services, and schedule strategy calls, all while balancing speed and personalisation.",
  },
  {
    tabContent: [
      {
        heading: "Pipeline view",
        content:
          "Track candidates and roles from outreach to shortlisting and final selection.",
        alt: "Pipeline view",
      },
      {
        heading: "WhatsApp updates",
        content:
          "Notify candidates about interview schedules, role status, or client feedback instantly.",
        alt: "WhatsApp updates",
      },
      {
        heading: "AI Assist communication",
        content:
          "Personalise candidate and recruiter conversations with suggested messages.",
        alt: "AI Assist communication",
      },
      {
        heading: "Task and event logging",
        content:
          "Stay on top of every interview, client call, or document submission in real-time.",
        alt: "Task and event logging",
      },
    ],
    image: realWorldImage6,
    alt: "Staffing and recruitment firms",
    subtitle:
      "Recruitment SDRs connect with hiring managers and job seekers, juggling multiple roles, companies, and follow-up stages.",
  },
];

const SalesDevReps = () => {
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const [activeCompare, setActiveCompare] = useState("#section0");

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const classes = useStyles();
  const [activeAccordian, setActiveAccordian] = useState(0);
  const sectionRef = useRef(null);
  const timeoutRef = useRef(null);
  const isInViewRef = useRef(false); // track if section is visible

  // Clear timeout
  const clearTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  // Schedule next change
  const scheduleNext = () => {
    clearTimer();
    if (!isInViewRef.current) return; // only autoplay if section is visible

    timeoutRef.current = setTimeout(() => {
      setActiveAccordian((prev) => (prev + 1) % experienceList.length);
    }, AUTO_PLAY_INTERVAL);
  };

  // Start/pause autoplay based on scroll visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          isInViewRef.current = true;
          scheduleNext(); // resume autoplay
        } else {
          isInViewRef.current = false;
          clearTimer(); // pause autoplay
        }
      },
      { threshold: 0.3 } // section is considered "in view" when 30% visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
      clearTimer();
    };
  }, [experienceList.length]);

  // Reschedule on activeAccordian change
  useEffect(() => {
    scheduleNext();
    return () => clearTimer();
  }, [activeAccordian, experienceList.length]);

  // Handle user click
  const handleAccordionClick = (index) => {
    setActiveAccordian(index);
    // scheduleNext will run via useEffect so this stays open full interval
  };

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 2) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollPosition(currentScrollY);
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // setSubMenuOpen(false);
        // setIsVisible(false);
      } else {
        // setSubMenuOpen(false);
        // setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const { ref, inView } = useInView({
    threshold: 0.5, // adjust as needed
    triggerOnce: false,
  });

  const benifitList = [
    {
      img: industryIntegration,
      title: "Never miss a lead, never miss a sale",
      desc: "Experience the power of the CRM system to keep up with the speed and scale of your business. Pepper Cloud streamlines prospecting, automates outreach, and gives real-time visibility into every lead interaction. With WhatsApp integration, AI feature, and easy mobile access, SDRs can respond faster and stay productive on the go. It ensures nothing slips through the cracks and every lead gets the right attention at the right time.",
    },
  ];
  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(`.${classes.adaptsBox}:first-child`),
      document.querySelector(`.${classes.adaptsBox}.blueCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.regularCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.purpleCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.greenCard`),
      ...document.querySelectorAll(`.${classes.adaptsBox}.sblueCard`), // Add regularCards
    ];

    cardsToAnimate.forEach((card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      // Set initial top-right position for the glass effect
      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150; // Adjust this value to position from right edge
        const topRightY = 0; // Top position

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Call it initially
      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      // Store handlers on the card element for cleanup
      card.handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      // Add event listeners
      card.addEventListener("mousemove", handleMouseMove);
      card.addEventListener("mouseenter", handleMouseEnter);
      card.addEventListener("mouseleave", handleMouseLeave);
      window.addEventListener("resize", setInitialPosition);
    });

    // Cleanup
    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card) return;

        const handlers = card.handlers;
        if (handlers) {
          card.removeEventListener("mousemove", handlers.mousemove);
          card.removeEventListener("mouseenter", handlers.mouseenter);
          card.removeEventListener("mouseleave", handlers.mouseleave);
          window.removeEventListener("resize", handlers.resize);
        }
      });
    };
  }, [classes]);
  const faqs = [
    {
      question: "What is a CRM for sales development reps?",
      answer: (
        <>
          A CRM for SDRs helps sales development teams manage outreach, qualify
          leads, and pass opportunities to AEs. It automates workflows,
          centralises lead data, and improves productivity.
        </>
      ),
    },
    {
      question: "How can CRM help with sales outreach?",
      answer: (
        <>
          A good CRM automates follow-ups, tracks engagement, and provides
          complete prospect history—making every outreach smarter and more
          timely.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud suitable for SDR teams in small businesses?",
      answer: (
        <>
          Yes. Pepper Cloud is built for SMEs and growing teams, offering
          flexible plans and intuitive features that help SDRs perform
          efficiently.
        </>
      ),
    },
    {
      question: "What are the benefits of CRM for sales?",
      answer: (
        <>
          Benefits include better lead management, faster follow-ups, improved
          team alignment, and stronger conversion rates. It helps SDRs focus on
          selling—not admin.
        </>
      ),
    },
    {
      question: "Can I automate SDR tasks with Pepper Cloud?",
      answer: (
        <>
          Absolutely. You can automate email sequences, lead assignments,
          follow-ups, and activity tracking—so your SDR team never misses a
          step.
        </>
      ),
    },
    {
      question: "How to use CRM for sales development?",
      answer: (
        <>
          Start by capturing leads, segmenting your outreach, automating
          follow-ups, and tracking outcomes in real time. Pepper Cloud makes
          this simple with ready-to-use workflows.
        </>
      ),
    },
  ];

  const adaptList = [
    {
      pointer: "Easy lead capture and tracking",
      desc: "Capture and convert leads automatically from multiple channels.",
      img: salesImg1,
      alt: "Easy lead capture and tracking",
      className: "purpleCard",
    },
    {
      pointer: "WhatsApp and email integration",
      desc: "Connect with prospects instantly via messaging and email tools.",
      img: salesImg2,
      alt: "WhatsApp and email integration",
      className: "regularCard",
    },
    {
      pointer: "Smart reminders and follow-ups",
      desc: "Automate follow-ups with AI-powered reminders and task scheduling.",
      img: salesImg3,
      alt: "Smart reminders and follow-ups",
      className: "purpledark",
    },
    {
      pointer: "Real-time alerts and updates",
      desc: "Get instant real-time alerts and updates. Take action when it matters most.",
      img: salesImg4,
      alt: "Real-time alerts and updates",
      className: "greenCard",
    },
    {
      pointer: "Conversation history",
      desc: "Personalise conversations easily by understanding conversation context.",
      img: salesImg5,
      alt: "Conversation history",
      className: "sblueCard",
    },
    {
      pointer: "Access via mobile CRM",
      desc: "Manage leads, tasks, and conversations anytime, anywhere via mobile CRM.",
      img: salesImg6,
      alt: "Access via mobile CRM",
      className: "blueCard",
    },
  ];

  const clientList = [
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
    {
      img: adaptImg1,
    },
    {
      img: adaptImg2,
    },
    {
      img: adaptImg3,
    },
    {
      img: adaptImg4,
    },
    {
      img: adaptImg5,
    },
    {
      img: adaptImg6,
    },
    {
      img: adaptImg7,
    },
  ];

  // sales rep contents
  const bannerPoints = [
    "WhatsApp integrated",
    "AI-powered sales insights",
    "Custom knowledge base",
    "Easy sales tracking updates ",
  ];
  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot",
    "Zoho CRM",
    "Pipedrive",
    "Freshsales",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud is the best CRM for sales development reps who want to prospect smarter and qualify faster. With AI-powered automation, multichannel communication, and real-time reporting, SDRs can stay focused on what matters most—booking qualified meetings.",
      img: compareItemImg1,
      alt: "Pepper Cloud CRM",
      features: [
        {
          title: "Lead qualification tools",
          desc: "Score and segment leads based on source, activity, and engagement.",
        },
        {
          title: "Workflow automation",
          desc: "Automate follow-ups, reminders, and lead routing to AEs.",
        },
        {
          title: "Multichannel communication",
          desc: "Connect with leads across WhatsApp, email, calls, and chat.",
        },
        {
          title: "Prospect history view",
          desc: "See the full timeline of activity for every lead in one place.",
        },
        {
          title: "Sales performance tracking",
          desc: "Monitor outreach metrics and team productivity.",
        },
      ],
    },
    {
      title: "HubSpot",
      desc: "HubSpot CRM is a popular choice for SDR teams in startups and mid-sized companies. It offers solid outreach features and native integration with email and calling tools.",
      img: compareItemImg2,
      alt: "HubSpot CRM",
      features: [
        {
          title: "Deal stages for SDR workflows",
          desc: "Customise pipelines to align with your qualification process.",
        },
        {
          title: "Contact activity timeline",
          desc: "View a complete history of engagement in one place.",
        },
        {
          title: "Reporting dashboard",
          desc: "Track productivity, lead status, and conversion insights.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM supports sales development with flexible automation and pipeline tools. It’s ideal for SDRs who handle both outbound and inbound leads.",
      img: compareItemImg3,
      alt: "Zoho CRM",
      features: [
        {
          title: "Custom workflows",
          desc: "Automate follow-ups, tasks, and lead nurturing sequences.",
        },
        {
          title: "Lead scoring",
          desc: "Prioritise prospects based on engagement, source, and intent signals.",
        },
        {
          title: "Smart dashboards",
          desc: "Get real-time visibility into lead progress and outreach performance.",
        },
      ],
    },
    {
      title: "Pipedrive",
      desc: "Pipedrive is a visual CRM built for activity-based selling. It’s best for SDRs who manage a high volume of outbound outreach.",
      img: compareItemImg4,
      alt: "Pipedrive",
      features: [
        {
          title: "Activity tracking dashboard",
          desc: "Monitor daily outreach, call logs, and email performance.",
        },
        {
          title: "Lead segmentation",
          desc: "Filter prospects by source, region, or status for focused targeting.",
        },
        {
          title: "Mobile-friendly interface",
          desc: "Stay on top of outreach activities on the go.",
        },
      ],
    },
    {
      title: "Freshsales",
      desc: "Freshsales by Freshworks offers AI-assisted prospecting and engagement tools, making it a good fit for growing SDR teams.",
      img: compareItemImg5,
      alt: "Freshsales",
      features: [
        {
          title: "Freddy AI insights",
          desc: "Get data-driven recommendations on when and how to engage leads.",
        },
        {
          title: "Email and call tracking",
          desc: "Log every touchpoint automatically for full outreach visibility.",
        },
        {
          title: "Lead routing workflows",
          desc: "Assign qualified leads to AEs with custom conversion rules.",
        },
      ],
    },
  ];

  const broadcastList = [
    {
      pointer: "CRM for sales development reps",
      card: {
        pointer: [
          "Qualify leads, automate outreach, and book meetings faster with integrated calling and task tools.",
        ],
        img: broadcastImg2,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: "#014957",
        backgroundImage: "linear-gradient(to bottom, #014957, #028ba6)",
      },
    },
    {
      pointer: "CRM for marketing teams",
      card: {
        pointer: [
          "Launch campaigns and capture more leads with ease while tracking performance in real-time and managing all campaign activities.",
        ],
        img: broadcastImg3,
        alt: "Create whatsapp broadcast message​",
        backgroundColor: " #31114b",
        backgroundImage: "linear-gradient(to bottom, #31114b, #783ca8);",
      },
    },
    {
      pointer: "CRM for customer support teams",
      card: {
        pointer: [
          "Respond faster, manage tickets efficiently, and improve satisfaction with smart support workflows.",
        ],
        img: broadcastImg4,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#2788e7",
        backgroundImage: "linear-gradient(to bottom, #2788e7, #783ca8)",
      },
    },
    {
      pointer: "CRM for business owners",
      card: {
        pointer: [
          "Gain full visibility and control from one platform with real-time insights, revenue trends, and business growth metrics.",
        ],
        img: broadcastImg5,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: "#09939a",
        backgroundImage: " linear-gradient(to bottom, #09939a, #783ca8)",
      },
    },
    {
      pointer: "CRM for IT and tech teams",
      card: {
        pointer: [
          "Streamline service delivery, automate workflows, and manage client support with ease.",
        ],
        img: broadcastImg1,
        alt: "CRM for Whatsapp broadcast",
        backgroundColor: " #0A2F4F",
        backgroundImage: " linear-gradient(180deg, #0A2F4F 0%, #2576BB 100%)",
      },
    },
  ];

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <main>
      <SEO
        description={
          "Discover the best CRM for sales development reps to manage leads, automate outreach, and book more meetings. Try Pepper Cloud CRM today."
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="Best crm for sales reps,Sales agents,Best crm for sales teams,best crm software,Crm software for sales and marketing,best sales crm,CRM software for small businesses"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/teams/best-crm-for-sales-reps/"}
        title={"CRM for sales development reps | Pepper Cloud"}
      />

      <section className={classes.SalesRepSection}>
        <div className="container">
          <div className={classes.salesRepContainer}>
            <div className={classes.salesSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64 font-white "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Best CRM for sales development reps
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  font-white bannerDescription"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Pepper Cloud empowers sales development reps to prospect
                smarter, engage instantly, and turn more leads into revenue, all
                from one powerful platform.
              </motion.p>
              <div className={classes.bannerPoint}>
                {bannerPoints.map((point) => (
                  <div className={classes.banerPointItem}>
                    <img src={bannerTick} />
                    <motion.p
                      className="font-wix-regular font-18 font-white"
                      key={`banner-point-${point}`}
                    >
                      {point}
                    </motion.p>
                  </div>
                ))}
              </div>

              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-18 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={"/contact/"}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a free demo
                </Link>
              </div>
            </div>
            <motion.div
              className={classes.aiSectionRight}
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <LazyImage
                alt={"WhatsApp CRM"}
                source={salesRepHeroImg}
                width={"100%"}
              />
            </motion.div>
          </div>
        </div>
      </section>
      <section className={classes.Client}>
        <div className="container">
          <p className="font-24 font-wix-semibold">
            Trusted by leading businesses for outstanding efficiency
          </p>
          <Swiper
            modules={[Autoplay]}
            className={classes.adaptSlider}
            grabCursor={true}
            loop={true}
            slidesPerView="auto"
            spaceBetween={30}
            speed={6000} // slow speed for smooth flow
            autoplay={{
              delay: 0, // no delay, continuous movement
              disableOnInteraction: false, // keeps looping even on hover/touch
            }}
            freeMode={true} // allows continuous smooth scroll
            freeModeMomentum={false} // disables snapping effect
            breakpoints={{
              0: {
                slidesPerView: 2,
                spaceBetween: 50,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 100,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 100,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 100,
              },
            }}
          >
            {clientList.map((point) => (
              <SwiperSlide className="client-logo">
                <div>
                  <img
                    // alt={point.card.alt}
                    src={point.img}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {benifitList.map((benifit) => (
        <section className={classes.integrationSection}>
          <div className="container">
            <div className={classes.integrationHeader}>
              <div className={classes.integrationRight}>
                <motion.img
                  alt={benifit.title}
                  className={classes.integrationRightImage}
                  src={benifit.img}
                  initial={{ opacity: 0, y: -80 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  viewport={{ once: true, amount: 0.2 }}
                />
              </div>
              <div className={classes.integrationLeft}>
                <motion.h2
                  className="font-wix-semibold font-56 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.title}
                </motion.h2>
                <motion.p
                  className="font-wix-regular font-18 color-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {benifit.desc}
                </motion.p>
              </div>
            </div>
          </div>
        </section>
      ))}

      <section className={classes.salesCrmCarousel}>
        <div className="container">
          <div className="crmDevReps">
            <motion.div className="header-section ">
              <motion.h2
                className="font-wix-semibold font-56 color-black1"
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true, amount: 0.2 }}
              >
                Tools every SDR needs to win more opportunities
              </motion.h2>
              <motion.p
                className="font-wix-regular font-18 color-black2"
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true, amount: 0.2 }}
              >
                Sales development reps need more than just a contact
                database,they need a smart, responsive, and easy-to-use CRM that
                helps them work faster and smarter. From lead capture to
                follow-ups, SDRs rely on tools that reduce manual effort and
                increase their chances of success.
              </motion.p>
            </motion.div>

            <div className="cardBlocksSales">
              {adaptList.map((point, index) => (
                <motion.div
                  className={`${classes.adaptsBox} ${point.className}`}
                  key={index}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true, amount: 0.2 }}
                >
                  <div className={classes.adaptBoxHeader}>
                    <img
                      className={classes.adaptBoxImg}
                      src={point.img}
                      alt=""
                    />
                    <p className="font-18 font-wix-semibold lineHeight-1">
                      {point.pointer}
                    </p>
                  </div>
                  <div className={classes.adaptDescription}>
                    <p className="font-wix-regular font-14">{point.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className={classes.accordianTabs}>
        <div className="container">
          <div className="headercenterContainer">
            <motion.h2
              className="font-wix-semibold font-56 text-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is best for SDRs
            </motion.h2>
            <p className="font-18 font-wix-regular text-black2">
              Pepper Cloud CRM is built to help sales development reps work
              smarter, not harder. With powerful features tailored to
              prospecting and follow-ups, SDRs can focus on what matters,booking
              qualified meetings faster.
            </p>
          </div>
          <div className={classes.experienceInnerContainer}>
            <div className={classes.experienceContainerLeft} ref={sectionRef}>
              {experienceList.map((faq, index) => (
                <motion.div
                  className={clsx(
                    classes.faqBoxAccordian,
                    index === activeAccordian && "active",
                    "text-color2"
                  )}
                  key={`faq-${index}`}
                  onClick={() => handleAccordionClick(index)}
                  transition={{ duration: 1, delay: index * 0.01 }}
                  whileInView={{ opacity: [0, 1], y: [50, 0] }}
                >
                  <div className={classes.experienceHeader}>
                    <h3 className="font-20 font-wix-semibold">{faq.title}</h3>
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                  </div>

                  <Collapse
                    className={classes.collapseBody}
                    in={activeAccordian === index}
                  >
                    <p className="font-18 font-wix-regular color-black2 exp-desc">
                      {faq.desc}
                    </p>
                    <motion.img
                      alt={faq.alt}
                      initial={{ opacity: 1, y: 20 }}
                      src={faq.img}
                      transition={{ duration: 0.3 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      style={{
                        backgroundImage: `url(${faq.bgImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    />
                  </Collapse>
                </motion.div>
              ))}
            </div>
            <div className={classes.experienceContainerRight}>
              {experienceList.map(
                (experience, index) =>
                  index === activeAccordian && (
                    <div
                      className="rightContent"
                      style={{
                        backgroundImage: `url(${experience.bgImg})`, // pass your image URL in experience.bgImage
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      <motion.img
                        src={experience.img}
                        initial={{ opacity: 0, x: 50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      />
                      <motion.p
                        className="font-18 font-wix-regular"
                        initial={{ opacity: 0, x: -50 }} // start 50px left, invisible
                        whileInView={{ opacity: 1, x: 0 }} // animate to normal position
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        viewport={{ once: true, amount: 0.2 }} // trigger when 20% visible, only once
                      >
                        {experience.desc}
                      </motion.p>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section className={classes.combineSection}>
        <div className={classes.integrationContent}>
          <motion.h2
            className="font-wix-semibold font-56 color-white"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Pepper Cloud CRM features tailored for business success
          </motion.h2>
        </div>

        <section className="sales-dev-logo-carousel">
          <div className="logos-container">
            <div className="scroll-container">
              <div className="logos-row" data-direction="left" data-speed="0.8">
                <div className="logos-track">
                  {logotrack1.map((logo) => (
                    <div
                      className="logo font-18 font-wix-medium"
                      key={logo.title}
                    >
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div
                className="logos-row"
                data-direction="right"
                data-speed="0.4"
              >
                <div className="logos-track">
                  {logotrack2.map((logo) => (
                    <div className="logo font-18 font-wix-medium">
                      <img alt={`${logo.title} integration`} src={logo.img} />
                      <p>{logo.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>
      </section>

      <section className={classes.realWorldTabs}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Application and use cases of CRM for sales development reps
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                IT services
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                EdTech and online training
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Financial services
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Digital marketing
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-semibold",
                  "font-18",
                  activeRealWorld === 4 && "active"
                )}
                onClick={() => setActiveRealWorld(4)}
              >
                 Staffing and recruitment
              </div>
            </div>
          </div>

          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        className="font-wix-regular font-18 color-black2"
                        initial={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                        whileInView={{ opacity: 1, y: 0 }}
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            className={classes.benfitListItem}
                            initial={{ opacity: 0, y: 20 }}
                            transition={{ duration: 0.3 }}
                            whileInView={{ opacity: 1, y: 0 }}
                          >
                            <LazyImage
                              alt={item.alt}
                              className={classes.benfitIcon}
                              source={bannerTick}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-18 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        alt={listItem.alt}
                        source={listItem.image}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="header">
          <motion.h2
            className="font-wix-semibold font-56 font-black1"
            initial={{ opacity: 1, y: 20 }}
            transition={{ duration: 0.3 }}
            whileInView={{ opacity: 1, y: 0 }}
          >
            Top 5 CRM software for sales development reps in 2025
          </motion.h2>
        </div>
        <div className={classes.compareSectionContainer}>
          <div className={classes.compareSectionContainerLeftSection}>
            {compareItems.map((item, index) => (
              <div
                className={clsx(
                  classes.compareSectionLeftItem,
                  activeCompare === `#section${index}` && "active"
                )}
                onClick={() => {
                  scrollToSection(`#section${index}`);
                  setActiveCompare(`#section${index}`);
                }}
              >
                <a
                  className={clsx(
                    "font-22 font-wix-medium font-black1",
                    activeCompare === `#section${index}` && "font-wix-semibold"
                  )}
                  href={`#section${index}`}
                >
                  {item}
                </a>
              </div>
            ))}
          </div>
          <div className={classes.compareSectionContainerRightSection}>
            {compareData.map((data, outerIndex) => (
              <div
                className={classes.compareItemContainer}
                id={`#section${outerIndex}`}
              >
                <h3
                  className="font-40 font-wix-semibold font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.title}
                </h3>
                <p
                  className="font-wix-regular font-18 font-black1"
                  initial={{ opacity: 1, y: 20 }}
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  {data.desc}
                </p>
                <img alt={data.alt} className="productImage" src={data.img} />
                <div className={classes.faqsContainer}>
                  {data.features.map((faq, innerIndex) => (
                    <motion.div
                      className={classes.faqBox}
                      onClick={() =>
                        setActiveAccordian(
                          `${outerIndex}-${innerIndex}` === activeAccordian
                            ? -1
                            : `${outerIndex}-${innerIndex}`
                        )
                      }
                      transition={{ duration: 1, delay: innerIndex * 0.01 }}
                      whileInView={{ opacity: [0, 1], y: [50, 0] }}
                    >
                      <div className={classes.topFiveHeader}>
                        <h3 className="font-20 font-wix-semibold">
                          {faq.title}
                        </h3>
                        <img
                          alt="Arrow"
                          className={clsx(
                            classes.downArrow,
                            `${outerIndex}-${innerIndex}` === activeAccordian &&
                              "active"
                          )}
                          src={downArrow}
                        />
                      </div>
                      <Collapse
                        className={classes.body}
                        in={activeAccordian === `${outerIndex}-${innerIndex}`}
                      >
                        <p className="font-18 font-wix-regular color-black2">
                          {faq.desc}
                        </p>
                      </Collapse>
                    </motion.div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className={classes.testimonials}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Real stories. Real results."}
          noButton={true}
        />
      </div>
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#FFF"}
          faqs={faqs}
          heading={"Frequently asked question - CRM for sales development reps"}
        />
      </div>

      <DesignCrmCarousel backgroundImage={`url(${designbg})`} bgColor={""} />
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Turn conversations into conversions with Pepper Cloud CRM.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SalesDevReps;
